module.exports = __webpack_public_path__ + "img/ic-checked.86accdb4.svg";